// Prorata helpers — must mirror backend/utils/prorata.go so the form preview
// matches the amounts the server actually puts on the receipt.

// Parse a yyyy-MM-dd string into a UTC date, ignoring time zones
const parseDay = (value) => {
  if (!value) return null;
  const [year, month, day] = String(value).slice(0, 10).split('-').map(Number);
  if (!year || !month || !day) return null;
  return new Date(Date.UTC(year, month - 1, day));
};

const MS_PER_DAY = 24 * 60 * 60 * 1000;

/**
 * Number of days covered by a period, both start and end date included.
 */
export const daysInPeriod = (start, end) => {
  const s = parseDay(start);
  const e = parseDay(end);
  if (!s || !e || e < s) return 0;
  return Math.round((e - s) / MS_PER_DAY) + 1;
};

/**
 * Fraction of a full month's rent the period represents. Every calendar month
 * the period overlaps contributes its covered days divided by that month's
 * length, so a complete calendar month always yields exactly 1.
 */
export const prorationFactor = (start, end) => {
  const s = parseDay(start);
  const e = parseDay(end);
  if (!s || !e || e < s) return 0;

  let factor = 0;
  let cur = s;
  while (cur <= e) {
    const monthEnd = new Date(Date.UTC(cur.getUTCFullYear(), cur.getUTCMonth() + 1, 0));
    const segmentEnd = monthEnd < e ? monthEnd : e;
    const days = Math.round((segmentEnd - cur) / MS_PER_DAY) + 1;
    factor += days / monthEnd.getUTCDate();
    cur = new Date(segmentEnd.getTime() + MS_PER_DAY);
  }
  return factor;
};

/**
 * Round an amount to two decimals, the way the backend stores it.
 */
export const roundMoney = (amount) => Math.round(amount * 100) / 100;
